export const environment = {
  production: true,

  alApiUrl: 'https://api.libreriaamericalatina.com/api/v1',
  tokenExpiration: 1000000000,
  idleTime: 100000000,
  rootUrl: 'http://www.libreriaamericalatina.com/libros/',
  coversUrl: 'https://imagenesal.bros.me/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts